export class RequestAlternatePnPostModel {
  public RequestId?: number;
  public AltPn?: string;
  public AltSn?: string;
  public Status?: number;
}

export class RequestAlternatePnPutModel {
  public id?: number;
  public RequestId?: number;
  public AltPn?: string;
  public AltSn?: string;
  public Status?: number;
  public Remark?: string;
  public UpdatedBy?: string;
  public UpdatedDate?: Date;
}
